import React from 'react';
import { ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, } from '@voltmoney/schema';
import GoogleLogin from 'react-google-login';
import { ButtonBase } from '../button/Button.base';
import { Platform } from 'react-native';
import { GoogleSignin } from '@react-native-google-signin/google-signin';
const GoogleButton = ({ id, label = 'Login with Google', clientID = '62646021413-queb1g13go0snvnotl0ee06t68jcgb98.apps.googleusercontent.com', action, triggerAction, }) => {
    const onResponse = async (response) => {
        await triggerAction({
            ...action,
            payload: {
                ...action.payload,
                value: Platform.OS === 'web'
                    ? response.profileObj.email
                    : response.user.email,
            },
        });
    };
    const mobileSignIn = async () => {
        try {
            await GoogleSignin.hasPlayServices();
            const userInfo = await GoogleSignin.signIn();
            await onResponse(userInfo);
        }
        catch (error) {
            console.warn('Google error-> ', error);
        }
    };
    const _renderGoogleButton = (onPress) => (React.createElement(ButtonBase, { id: id, onPress: onPress, stack: {
            type: StackType.row,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
        }, bgColor: ColorTokens.Transparent, labelColor: ColorTokens.Primary_100, label: label, fontFamily: FontFamilyTokens.Inter, borderColor: ColorTokens.Primary_100, fontSize: FontSizeTokens.SM, width: ButtonWidthTypeToken.FULL, iconName: IconTokens.GoogleSVG, icon: {
            name: IconTokens.GoogleSVG,
            size: IconSizeTokens.MD,
        }, paddingVertical: SizeTypeTokens.MD, paddingHorizontal: SizeTypeTokens.MD }));
    if (Platform.OS === 'web') {
        return (React.createElement(GoogleLogin, { clientId: clientID, render: (renderProps) => _renderGoogleButton(renderProps.onClick), buttonText: 'Login', onSuccess: onResponse, onFailure: onResponse, cookiePolicy: 'single_host_origin', isSignedIn: false }));
    }
    else {
        return _renderGoogleButton(mobileSignIn);
    }
};
export default React.memo(GoogleButton);
export { GoogleButton };
